import {SAVE_FILTER_VALUES} from "actions/filterActions";

export default (previousState = {}, { type, payload }) => {
    switch (type) {
      case SAVE_FILTER_VALUES:
        return { ...previousState, ...payload};
    default:
        return previousState;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/filter.js